import { render, staticRenderFns } from "./CreateMenuShortcutPage.vue?vue&type=template&id=5488caa8&scoped=true"
import script from "./CreateMenuShortcutPage.vue?vue&type=script&lang=js"
export * from "./CreateMenuShortcutPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488caa8",
  null
  
)

export default component.exports